import { forwardRef, ReactNode } from 'react';
import {
  Checkbox as MuiCheckbox,
  CheckboxProps as MuiCheckboxProps,
  FormControl,
  FormControlLabel,
  FormControlLabelProps,
  FormControlProps,
  FormHelperText,
  styled,
} from '@mui/material';

export type CheckboxProps = Pick<
  MuiCheckboxProps,
  'checked' | 'checkedIcon' | 'color' | 'icon' | 'size'
> &
  Pick<FormControlLabelProps, 'labelPlacement' | 'onChange'> &
  Pick<FormControlProps, 'className' | 'disabled' | 'error' | 'required'> & {
    helperText?: ReactNode;
    label: ReactNode;
  };

const StyledFormHelperText = styled(FormHelperText)`
  margin: ${({ theme }) => theme.spacing(-0.75, 0, 0, 3.25)};
`;

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  (
    {
      checked,
      checkedIcon,
      className,
      color,
      disabled,
      error,
      helperText,
      icon,
      label,
      labelPlacement,
      onChange,
      required,
      size,
    },
    ref
  ) => (
    <FormControl className={className} disabled={disabled} error={error} required={required}>
      <FormControlLabel
        control={
          <MuiCheckbox
            checked={checked}
            checkedIcon={checkedIcon}
            color={color}
            icon={icon}
            ref={ref}
            size={size}
          />
        }
        disabled={disabled}
        label={label}
        labelPlacement={labelPlacement}
        onChange={onChange}
      />

      {helperText && <StyledFormHelperText>{helperText}</StyledFormHelperText>}
    </FormControl>
  )
);
